export enum TransferStatus {
  Pending = 0,
  Complete = 1
}
